import React from 'react';
import './Main.css';
import Arrow from '../../assets/icon-arrow.svg';
import Quote from '../../assets/icon-quotes.svg';
import Avatar from '../../assets/avatar-testimonial.jpg';
import illustration from '../../assets/illustration-2.svg';
import Subscription from '../Subscription/Subscription';

function Main() {
    return (
        <main>
            <div className='main-content'>
                <div className='main-info'>
                    <h1>Stay productive, wherever you are</h1>
                    <p className='main-paragraph'>
                    Never let location be an issue when accessing your files. Fylo has
                    you covered for all of your file storage needs.
                    </p>
                    <p className='main-paragraph'>
                    Securely share files and folders with friends, family and
                    colleagues for live collaboration. No email attachments required!
                    </p>
                    <div className='main-link'>
                        <a
                            href='https://reactjs.org'
                            target='_blank'
                            rel='noopener noreferrer'
                        >
                            {' '}
                            See how Fylo works
                        </a>
                        <img className='main-arrow' src={Arrow} alt='arrow icon' />
                    </div>
                    <div className='main-box'>
                        <img src={Quote} alt='quote icon' />
                        <p className='main-box-content'>
                            Fylo has improved our team productivity by an order of
                            magnitude. Since making the switch our team has become a
                            well-oiled collaboration machine.
                        </p>
                        <div className='main-box-title'>
                            <img
                            className='main-box-avatar'
                            src={Avatar}
                            alt='Kyle Burton'
                            />
                            <div>
                            <p className='main-box-name'>
                                <strong>Kyle Burton</strong>
                                <br />
                                Founder & CEO, Huddle
                            </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='main-img'>
                    <img src={illustration} alt='main illustration' />
                </div>
            </div>
            <Subscription />   
        </main>
    );
}

export default Main;
